import { useState, useEffect } from "react";
import { apiGet, apiSend, errorMessage } from "./api";
import "./RegisterCard.css";

function RegisterCard({ orgId, platform }) {
  const [org, setOrg] = useState(null);
  const [form, setForm] = useState({ name: "", surname: "", email: "", phone: "", birthday: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [orgMissing, setOrgMissing] = useState(false);

  // Le thème du commerçant (couleurs de la carte) ne s'applique volontairement
  // pas à cette page : elle garde sa palette neutre pour rester toujours lisible.
  // Sans le contrôle du statut HTTP, un 404 posait `org = {detail: ...}`
  // (truthy) : formulaire actif affichant « Fidélité undefined ».
  useEffect(() => {
    apiGet(`/api/organizations/${orgId}/public`, "Organisation introuvable")
      .then(setOrg)
      .catch(() => setOrgMissing(true));
  }, [orgId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // Le champ date vide envoie "" : l'API attend null pour « non renseigné »
      const data = await apiSend("/api/register-card", "POST",
        { ...form, birthday: form.birthday || null, org_id: parseInt(orgId), platform },
        "Vérifiez les informations saisies");
      setResult(data);
    } catch (e) {
      setError(errorMessage(e, "Vérifiez les informations saisies"));
    }
    setLoading(false);
  };

  const logoUrl = org && org.has_logo ? `/api/organizations/${orgId}/logo` : null;

  if (orgMissing) {
    return (
      <div className="reg-container">
        <div className="reg-card">
          <h1>Commerce introuvable</h1>
          <p className="reg-note">
            Ce lien ne correspond à aucun commerce. Vérifiez auprès de l'établissement.
          </p>
        </div>
      </div>
    );
  }

  if (result) {
    return (
      <div className="reg-container">
        <div className="reg-card reg-success">
          {logoUrl && <img src={logoUrl} alt="Logo" className="reg-logo" />}
          <h1>Carte créée !</h1>
          <p className="reg-card-id">{result.card_id}</p>
          <p>Votre carte de fidélité a été créée avec succès.</p>
          {platform === "apple" && result.apple_wallet_url ? (
            <a href={result.apple_wallet_url} className="reg-wallet-btn reg-wallet-apple">
              Ajouter à Apple Wallet
            </a>
          ) : result.wallet_url ? (
            <a href={result.wallet_url} className="reg-wallet-btn" target="_blank" rel="noopener noreferrer">
              Ajouter à Google Wallet
            </a>
          ) : (
            <p className="reg-note">Conservez votre identifiant de carte.</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="reg-container">
      <div className="reg-card">
        {logoUrl && <img src={logoUrl} alt="Logo" className="reg-logo" />}
        <h1>{org ? `Fidélité ${org.name}` : "Chargement..."}</h1>
        {org && <p className="reg-subtitle">Créez votre carte de fidélité</p>}
        <form onSubmit={handleSubmit}>
          {error && <div className="reg-error">{error}</div>}
          <label>Nom</label>
          <input name="name" value={form.name} onChange={handleChange} required />
          <label>Prénom</label>
          <input name="surname" value={form.surname} onChange={handleChange} required />
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} required />
          <label>Téléphone (optionnel)</label>
          <input name="phone" type="tel" value={form.phone} onChange={handleChange} />
          <label>Date d'anniversaire (optionnel)</label>
          <input
            name="birthday"
            type="date"
            value={form.birthday}
            onChange={handleChange}
            max={new Date().toISOString().slice(0, 10)}
          />

          <button type="submit" className="reg-submit" disabled={loading || !org}>
            {loading ? "Création..." : "Obtenir ma carte"}
          </button>
          <p className="reg-privacy">
            Ces informations servent uniquement à la gestion de votre carte de
            fidélité chez {org ? org.name : "ce commerce"}.{" "}
            <a href="/confidentialite" target="_blank" rel="noopener noreferrer">
              Politique de confidentialité
            </a>
          </p>
        </form>
      </div>
    </div>
  );
}

export default RegisterCard;
